import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExamRoutingModule } from './exam-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, TimepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { ScoreCardTypeComponent } from './score-card-type/score-card-type.component';
import { ExamMasterComponent } from './exam-master/exam-master.component';
import { ExamScoreCardTypeClassMapComponent } from './exam-score-card-type-class-map/exam-score-card-type-class-map.component';
import { TermComponent } from './term/term.component';
import { ClassTermMapComponent } from './class-term-map/class-term-map.component';
import { ExamClassMapComponent } from './exam-class-map/exam-class-map.component';
import { ExamAchievementScaleComponent } from './exam-achievement-scale/exam-achievement-scale.component';
import { ClassAchievementScaleMapComponent } from './class-achievement-scale-map/class-achievement-scale-map.component';
import { PersonalSkillMasterComponent } from './personal-skill-master/personal-skill-master.component';
import { PersonalSkillActivityComponent } from './personal-skill-activity/personal-skill-activity.component';
import { PerssonalSkillActivityMapComponent } from './perssonal-skill-activity-map/perssonal-skill-activity-map.component';
import { PersonalSkillActivityStaffMapComponent } from './personal-skill-activity-staff-map/personal-skill-activity-staff-map.component';
import { GradeScaleComponent } from './grade-scale/grade-scale.component';
import { MarksGradingComponent } from './marks-grading/marks-grading.component';
import { GradeScaleClassMapComponent } from './grade-scale-class-map/grade-scale-class-map.component';
import { DisciplineMasterComponent } from './discipline-master/discipline-master.component';
import { DisciplineClassMapComponent } from './discipline-class-map/discipline-class-map.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ExamScheduleSetupComponent } from './exam-schedule-setup/exam-schedule-setup.component';
import { StudentElectiveComponent } from './student-elective/student-elective.component';
import { ExamCoScholasticStudentSetupComponent } from './exam-co-scholastic-student-setup/exam-co-scholastic-student-setup.component';
import { ExamStudentCoScholasticAssessmentComponent } from './exam-student-co-scholastic-assessment/exam-student-co-scholastic-assessment.component';
import { AssessmentFeedbackComponent } from './assessment-feedback/assessment-feedback.component';
import { AssessmentHealthComponent } from './assessment-health/assessment-health.component';
import { AssessmentDisciplineComponent } from './assessment-discipline/assessment-discipline.component';
import { GradedScoreCardComponent } from './graded-score-card/graded-score-card.component';
import { ExamStudentPromotionRemarksComponent } from './exam-student-promotion-remarks/exam-student-promotion-remarks.component';
import { ClassSubjectWiseMarksEntryComponent } from './class-subject-wise-marks-entry/class-subject-wise-marks-entry.component';
import { StudentReportCardComponent } from './report/student-report-card/student-report-card.component';
import { StudentReportCard12Component } from './report/student-report-card12/student-report-card12.component';
import { AdmitCardScheduleComponent } from './admit-card-schedule/admit-card-schedule.component';
import { AdmitCardScheduleSetupComponent } from './admit-card-schedule-setup/admit-card-schedule-setup.component';
import { AdmitCardComponent } from './admit-card/admit-card.component';
import { PrintAdmitCardComponent } from './print-admit-card/print-admit-card.component';
import { ReportcardTerm1Component } from './report/reportcard-term1/reportcard-term1.component';
import { ReportcardTerm2Component } from './report/reportcard-term2/reportcard-term2.component';
import { ReportcardExamWiseComponent } from './report/reportcard-exam-wise/reportcard-exam-wise.component';
import { MppsgReportTerm1Component } from './report/mppsg-report-term1/mppsg-report-term1.component';
import { MppsgReportTerm2Component } from './report/mppsg-report-term2/mppsg-report-term2.component';
import { RpsreportcardComponent } from './report/rpsreportcard/rpsreportcard.component';
import { DepsReportCardComponent } from './report/deps-report-card/deps-report-card.component';
import { TabulationSheetComponent } from './tabulation-sheet/tabulation-sheet.component';



@NgModule({
  declarations: [ScoreCardTypeComponent, ExamMasterComponent, ExamScoreCardTypeClassMapComponent,
    TermComponent, ClassTermMapComponent, ExamClassMapComponent, ExamAchievementScaleComponent, 
    ClassAchievementScaleMapComponent, PersonalSkillMasterComponent, PersonalSkillActivityComponent, 
    PerssonalSkillActivityMapComponent, PersonalSkillActivityStaffMapComponent, GradeScaleComponent,
     MarksGradingComponent, GradeScaleClassMapComponent, DisciplineMasterComponent, 
     DisciplineClassMapComponent, ExamScheduleSetupComponent, StudentElectiveComponent,
     ExamCoScholasticStudentSetupComponent, ExamStudentCoScholasticAssessmentComponent, 
     AssessmentFeedbackComponent, AssessmentHealthComponent, AssessmentDisciplineComponent, 
     GradedScoreCardComponent, ExamStudentPromotionRemarksComponent, ClassSubjectWiseMarksEntryComponent,
     StudentReportCardComponent, StudentReportCard12Component, AdmitCardScheduleComponent,
     AdmitCardScheduleSetupComponent, AdmitCardComponent, PrintAdmitCardComponent, 
     ReportcardTerm1Component, ReportcardTerm2Component, ReportcardExamWiseComponent, 
     MppsgReportTerm1Component, MppsgReportTerm2Component,RpsreportcardComponent,
     DepsReportCardComponent,TabulationSheetComponent],
  imports: [
    CommonModule,
    ExamRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TypeaheadModule.forRoot(),
    TimepickerModule.forRoot(),
  ]
})
export class ExamModule { }
